import { useCallback, useState } from 'react'

import { AssetFile } from '~generated/types'
import { downloadFromS3 } from '~lib/s3'
import { downloadFile } from '~lib/utils/files'

export default function useDownloadAssetFiles(assetsFiles: AssetFile[]) {
  const [loading, setLoading] = useState(false)

  const downloadAssetFiles = useCallback(async () => {
    try {
      setLoading(true)

      await Promise.all(
        assetsFiles?.map((file) => downloadFromS3(file.url).then((url) => downloadFile({ url, name: file.name })))
      )
    } finally {
      setLoading(false)
    }
  }, [assetsFiles])

  return [downloadAssetFiles, loading] as const
}
